import React from 'react';
import {useIntl} from 'react-intl';
import AbstractModalView from '../AbstractModalView';
import Button from '../Button';
import {clearSessionStorage} from "../../utils/sessionStorage";
import config from '../../config/common';
import close from '../../assets/close.svg';
import styles from './styles.module.scss';

const ButtonLogoutModal = () => {
  const intl = useIntl();
  const buttonLabel = intl.formatMessage({
    id: 'common-logout-button',
    defaultMessage: 'Logout'
  });
  const questionText = intl.formatMessage({
    id: 'common-logout-question-text',
    defaultMessage: 'Are you sure?'
  });
  const buttonOk = intl.formatMessage({
    id: 'common-logout-question-ok',
    defaultMessage: 'Yes'
  });
  const buttonCancel = intl.formatMessage({
    id: 'common-logout-question-cancel',
    defaultMessage: 'No'
  });

  const handleLogoutClick = () => {
    clearSessionStorage();
    window.location.href = `${config.client.href}${config.client.logout}`;
  };

  return (
    <AbstractModalView
      subPath={'logout-modal'}
      triggerContent={({openModal}) => (
        <Button
          type='button'
          variant='secondary'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal()
          }}
          label={buttonLabel}
          className={styles.logoutBtn}
        />
      )}
      modalContent={({closeModal}) => (
        <div className={styles.content}>
          <img
            src={close}
            alt="close"
            className={styles.closeIcon}
            onClick={closeModal}
          />
          <div className={styles.question}>{questionText}</div>
          <div className={styles.divider}/>
          <div className={styles.buttons}>
            <Button
              label={buttonOk}
              onClick={handleLogoutClick}
              className={styles.button}
            />
            <Button
              variant='secondary'
              label={buttonCancel}
              onClick={closeModal}
              className={styles.button}
            />
          </div>
        </div>
      )}
      customContentClassName={styles.modalContainer}
      customModalClassName={styles.modal}
    />
  )
};

export default ButtonLogoutModal;
